import React, { useRef, useState, useEffect, createContext } from 'react';
import { debugdiv, useMountEffect, ReadingsContext, DeviceContext } from '../ODevice';
import { API_URL, BASE_URL } from '../Constants';

export const encodeBase64 = (data) => {
    return Buffer.from(data).toString('base64');
}
export const decodeBase64 = (data) => {
    return Buffer.from(data, 'base64').toString('ascii');
}


// create context
const UserContext = createContext();

const sec_user = 'dummy';
const sec_pasw = 'dummy';
const API_Sec = 'HnIb 5KXN k7SU CPwt FiQJ ezsx';

const loginData = {
  username: "the-o-collector",
  password: "uB8c Ewyd hpKw FREA KYdj iTs4"
};

const loginheaders = {
  method: "post",
  mode: "cors",
  headers: new Headers({
    Authorization: "Basic " + encodeBase64("dummy:uB8c Ewyd hpKw FREA KYdj iTs4"),
    "Content-Type": "application/x-www-form-urlencoded",
  }),
  body: "foo=1&bar=2",
};

const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };



function WordpressAPI() {

    const functionname ='WordpressAPI';
    const [debugvisible, setDebugvisible] = useState(true);
    const [milliseconds, setMilliSeconds] = useState(0);
    const refDebugDiv = useRef();
    // This functions const
    const [user, setUser] = useState(null);
    const [RefErrorDiv, setRefErrorDiv] = useState('No Error');
    const [RefResponseDiv, setRefResponseDiv] = useState('No Response');



    // Only run once while after mounting
    useMountEffect(()=>{
        console.log( functionname  + '  is loaded');
        if (debugvisible) {
          refDebugDiv.current.style.display = 'unset';
        } else {
          refDebugDiv.current.style.display = 'none';
        }        
    });
  
    useEffect(() => {
      const interval = setInterval(() => {
        setMilliSeconds(milliseconds => milliseconds + 1);
      }, 100);
      return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        //do something here
        console.log('ran this thing');
        //jwt-auth/v1"
        //https://github.com/DoubleNemesis/ReactWordpressRestApi/blob/main/LoginAPI.js
        const dologin =() => {
            let formData = new FormData()
            formData.append('username', "dummy")
            formData.append('password', "dummy")


            fetch(API_URL + 'jwt-auth/v1/token',{
                method: 'POST',
                body: formData
            })
            .then((response) => response.json())
            .then((response) => setRefResponseDiv(JSON.stringify(response)))           
            .catch(error => console.log('error', error))

        }; 
    
    const fetchUser =() => {
        fetch(API_URL + 'wp/v2/users/me',loginheaders)
        .then((response) => response.json())
        .then((response => handleResponse(response)))
        .then((response) => setRefResponseDiv(JSON.stringify(response)))        
        .then((data) => console.log(data))
        .then((result) => setUser(result) && console.log(result))
        .catch(error => console.log('error', error))
        .then(error => setRefErrorDiv(JSON.stringify(error)));

        };
    
    const handleResponse = response =>{
        console.log('handeling a response')
        if (response.ok) {
            if ([401, 403].includes(response.status) ) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                //&& auth?.token
                console.log("wervanda")
            }         
        } 

    } ;

        const fetchUserMe =() => {              
              fetch("wordpress-react.local/wp-json/wp/v2/users/me", requestOptions)
                .then(response => response.json())
                .then(result => console.log(result))
                .catch(error => console.log('error', error));
            };

        
        dologin();

    }, []); // <- add a changing area here variable here like milliseconds

    

    
    const handleChangeChkDebug = event =>{
        console.log('clicked');
        if (event.target.checked) {
            console.log('✅ Checkbox is checked');
            refDebugDiv.current.style.display = 'unset';
          } else {
            console.log('⛔️ Checkbox is NOT checked');
            refDebugDiv.current.style.display = 'none';
          }
          setDebugvisible(debugvisible => !debugvisible);
        };


  
    return (
        <div>
            <div  style={debugdiv}>
                <input type="checkbox" defaultChecked={debugvisible} onChange={ handleChangeChkDebug } />&nbsp;
                <b>{ functionname }</b> 
            </div>
            <div  ref={refDebugDiv}>            
                <div><b>Response</b></div>
                <div> { RefResponseDiv } </div>
                <div><b>Error</b></div>
                <div> { RefErrorDiv } </div>
            </div>
        </div>
        
    );
  };
  

export default WordpressAPI;